import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=940132ac&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"
import style0 from "./page6.vue?vue&type=style&index=0&id=940132ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940132ac",
  null
  
)

export default component.exports